module.exports = __webpack_public_path__ + "media/western-osprey-2.44641fa8.mp3";